/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */

/**
 * Incident severity
 */
export type IncidentSeverity = (typeof IncidentSeverity)[keyof typeof IncidentSeverity];

export const IncidentSeverity = {
  MINOR: 'minor',
  MAJOR: 'major',
  CRITICAL: 'critical',
} as const;
